import { Seo } from "@/components/Seo";
import { AdminCard, AdminPageHead } from "@/components/admin/AdminUi";
import StoriesVideosManager from "@/components/admin/StoriesVideosManager";

export function Videos() {
  return (
    <div data-testid="cms-videos">
      <Seo title="Videos | Bahamas Kidney Association CMS" noindex />
      <AdminPageHead
        title="Videos & Stories Library"
        subtitle="Every story and video on the site lives here. Paste a YouTube link or upload a file, then choose where it appears."
      />
      <AdminCard>
        <div className="p-4">
          <StoriesVideosManager />
        </div>
      </AdminCard>
    </div>
  );
}

export default Videos;
